import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import services from '../../services';
import { useParams } from 'react-router-dom';

const
    StatusDropdownTable = ({
        openEditModalCell,
        item,
        StatusFields = [],
        handleSelectStatus,
        // handleUpdatedCustomField,
        deleteCustomField,
        getDefaultColorByValue,
        statusColors,
        setCustomeFieldId,
        customeFiedId,
        // filterStatusVal,
        handletaskUpdate,
        customprokey,
        setCustomprokey,

        updateCustomProKey,
        // selectedStatus,
        // setSelectedStatus,
        selectedFieldId,
        // handleStatusClick,
        // idx,
        taskItem,
        handleRemoveCustomField
    }) => {

        const [selectedStatusColor, setSelectedStatusColor] = useState(null);
        const [inputStatusEditValue, setInputStatusValue] = useState('');
        const [showOptionModal, setShowOptionModal] = useState(null);
        const [selecteStatusIndex, setSelecteStatusIndex] = useState(null);
        const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
        const [isMenuOpen, setIsMenuOpen] = useState(true);
        const modalRef = useRef(null);
        const { id } = useParams();
        const [hoveredId, setHoveredId] = useState(null);
        const statusOptions = StatusFields.map((status) => ({
            value: status?.customField?.value,
            label: status?.customField?.value,
            color: status?.customField?.color || getDefaultColorByValue(status?.customField?.value),
            id: status.id,
            index: status.index,
        }));






        const customStyles = {
            control: (base) => ({
                ...base,
                borderRadius: 8,
                boxShadow: '0 2px 8px #0001',
                border: '1px solid #ccc',
                minHeight: 38,
                fontSize: 14,
            }),
            option: (base, { isFocused }) => ({
                ...base,
                backgroundColor: isFocused ? '#f0f0f0' : '#fff',
                color: '#000',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }),
            singleValue: (base) => ({
                ...base,
                display: 'flex',
                alignItems: 'center',
            }),
            // menu: (provided) => ({
            //     ...provided,
            //     maxHeight: '150px',
            //     overflowY: 'auto',

            // }),
            // menuList: (provided) => ({
            //     ...provided,
            //     paddingTop: 0,
            //     paddingBottom: 0,
            // }),


        };

        const formatOptionLabel = (data, { context }) => (
            <div
                className="flex items-center justify-between w-full"
                onMouseEnter={() => setHoveredId(data.id)}
                onMouseLeave={() => setHoveredId(null)}
            >
                <span
                    className="inline-flex items-center rounded px-2 py-0.5 text-[13px] font-medium"
                    style={{
                        backgroundColor: data.color,
                        color: "white",
                    }}
                >
                    {data.label}
                </span>

                {context === "menu" && (
                    <div className="flex items-center gap-2">
                        {hoveredId === data.id && (
                            <i
                                className="bi bi-sliders text-gray-500 hover:text-black text-sm"
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setModalPosition({
                                        top: rect.bottom + window.scrollY,
                                        left: rect.left + window.scrollX,
                                    });

                                    setShowOptionModal(data.id);
                                    setInputStatusValue(data.label);
                                    setCustomeFieldId(data.id);
                                    setSelecteStatusIndex(data.index);
                                    setSelectedStatusColor(data.color);
                                }}
                            />
                        )}

                        <span
                            style={{
                                cursor: "grab",
                                fontSize: 14,
                            }}
                        >
                            ⋮⋮
                        </span>
                    </div>
                )}
            </div>

        );





        useEffect(() => {
            const handleMouseDownOutside = (event) => {
                if (modalRef.current && !modalRef.current.contains(event.target)) {
                    setShowOptionModal(null);
                }
            };
            document.addEventListener('mousedown', handleMouseDownOutside);
            return () => {
                document.removeEventListener('mousedown', handleMouseDownOutside);
            };
        }, []);

        function filterObjectsByIds(idArray, objectArray) {
            return objectArray?.filter(obj => idArray?.includes(obj.id));
        }

        const formattedTagNew = filterObjectsByIds(selectedFieldId, statusOptions);


        return (
            <div className="relative z-[999] w-[12vw]">

                <Select
                    options={statusOptions}
                    styles={customStyles}
                    placeholder="Select status"
                    isClearable={true}
                    formatOptionLabel={formatOptionLabel}
                    value={formattedTagNew}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    menuIsOpen={isMenuOpen}
                    onMenuClose={() => setIsMenuOpen(true)}
                    onChange={(option) => {
                        if (option) {
                            const { value, color, index, id } = option;
                            updateCustomProKey(item, id, '', taskItem);
                        } else {

                            handleRemoveCustomField(formattedTagNew[0]?.id, taskItem);
                        }
                    }}

                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();

                            handleSelectStatus(taskItem?.id, item?.id, e.target?.value, item, 'grey');
                        }
                    }}
                    menuPlacement="auto"
                />



                {statusOptions.map((status) => {
                    const isModalOpen = showOptionModal === status.id;
                    if (!isModalOpen) return null;

                    return (
                        <div
                            key={status.id}
                            ref={modalRef}
                            className="fixed z-50 w-60 bg-white border border-gray-300 shadow-lg rounded p-[13px]"
                            style={{
                                // top: `${modalPosition.top}px`,
                                transform: "translate(0px, -50px)"
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex justify-between items-center mb-2">
                                <h3 className="text-sm font-semibold">Option details</h3>
                                <i
                                    className="bi bi-trash text-black-500 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        deleteCustomField(customeFiedId, '', status);

                                    }}
                                />
                            </div>

                            <input
                                type="text"
                                className="w-full border border-black rounded px-2 py-1 text-sm mb-3"
                                value={inputStatusEditValue}
                                onChange={(e) => setInputStatusValue(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                            />

                            <div className="text-sm font-medium mb-2">Colors</div>

                            <div className="grid grid-cols-5 gap-2">
                                {statusColors.map((color) => (
                                    <div
                                        key={color}
                                        className="w-6 h-6 rounded-full cursor-pointer relative flex items-center justify-center"
                                        style={{ backgroundColor: color }}
                                        onClick={() => setSelectedStatusColor(color)}
                                    >
                                        {selectedStatusColor === color && (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-4 h-4 text-white"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth={3}
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                            </svg>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <div className="flex justify-end gap-2 mt-3">
                                <button
                                    className="text-xs bg-blue-500 text-white px-3 py-1.5 rounded-md hover:bg-blue-600 transition-colors"
                                    onClick={() => {
                                        setShowOptionModal(null);

                                        handleSelectStatus(taskItem?.id, item?.id, inputStatusEditValue, item, selectedStatusColor);
                                        // handleStatusClick(idx)
                                        // }
                                    }}
                                >
                                    Save
                                </button>
                                <button
                                    className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-300 transition-colors"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setShowOptionModal(null);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

export default StatusDropdownTable;